module.exports = __webpack_public_path__ + "img/Mars.ea7f35b7.png";